export default "__VITE_ASSET__K4C0K1nL__"